import { render, staticRenderFns } from "./MyCourseBundle.vue?vue&type=template&id=3a7ec85e&scoped=true&"
import script from "./MyCourseBundle.vue?vue&type=script&lang=js&"
export * from "./MyCourseBundle.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseBundle.vue?vue&type=style&index=0&id=3a7ec85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ec85e",
  null
  
)

export default component.exports